import React, {ReactNode} from 'react';
import {ClearIndicatorProps} from 'react-select';

import {RemoveButton} from './RemoveButton';

const noop = () => {
  // do nothing
};

const DEFAULT_CHILDREN = <RemoveButton removeCallback={noop} />;

interface OwnProps {
  children?: ReactNode;
}

type Props = OwnProps & ClearIndicatorProps;

export const DLSelectClearIndicator: React.FC<Props> = (props) => {
  const {
    children = DEFAULT_CHILDREN,
    getStyles,
    innerProps: {ref, ...restInnerProps},
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      // TS error conflict when using CSSProperties from react and CSSProperties from @emotion
      style={getStyles('clearIndicator', props)}
    >
      {children}
    </div>
  );
};

DLSelectClearIndicator.displayName = 'DLSelectClearIndicator';
